import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { IStore } from 'Store/.';
import { getIsFetchingContact } from 'Components/InfoContact/Redux/selectors';
import { getIsFetchingAbout } from 'Components/InfoAbout/Redux/selectors';
import { getIsFetchingJobs } from 'Components/InfoJobs/Redux/selectors';
import { getIsFetchingCustomerService } from 'Components/InfoCustomerService/Redux/selectors';
import { getIsFetchingFaq } from 'Components/InfoFaq/Redux/selectors';
import InfoContactContainer from 'Components/InfoContact/InfoContactContainer';
import InfoAboutContainer from 'Components/InfoAbout/InfoAboutContainer';
import InfoJobsContainer from 'Components/InfoJobs/InfoJobsContainer';
import InfoCustomerServiceContainer from 'Components/InfoCustomerService/InfoCustomerServiceContainer';
import InfoFaqContainer from 'Components/InfoFaq/InfoFaqContainer';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

export enum InfoSection {
  ABOUT = 'om',
  CONTACT = 'kontakt',
  CUSTOMER_SERVICE = 'callcenter',
  FAQ = 'faq',
  JOBS = 'jobb',
};

interface IPropsInternal {
  isFetchingAbout: boolean;
  isFetchingContact: boolean;
  isFetchingCustomerService: boolean;
  isFetchingFaq: boolean;
  isFetchingJobs: boolean;
}

interface ISectionRefMap {
  [section: string]: Element;
}

type Props = RouteComponentProps<{ section: string }> & IPropsInternal;

class InfoPageContainer extends React.PureComponent<Props> {
  private readonly sectionRefMap: ISectionRefMap = {};

  componentDidMount() {
    if (!this.isFetching(this.props)) {
      const { section } = this.props.match.params;
      this.scrollIntoView(section);
    }
  }
  componentDidUpdate(prevProps: Props) {
    const prevSection = prevProps.match.params.section;
    const newSection = this.props.match.params.section;
    if (
      newSection !== prevSection ||
      !this.isFetching(this.props) && this.isFetching(prevProps)
    ) {
      this.scrollIntoView(newSection);
    }
  }

  scrollIntoView = (section: string) => {
    const element = this.sectionRefMap[section];

    if (element) {
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  isFetching = (props: Props) => {
    return props.isFetchingContact || props.isFetchingAbout || 
      props.isFetchingJobs || props.isFetchingCustomerService || props.isFetchingFaq;
  }

  render() {

    if (this.isFetching(this.props)) {
      window.scrollTo(0, 0);
      
      return (
        <WrapperLayout>
          <Spinner height='lg' />
        </WrapperLayout>
      );
    }

    return (
      <>    
        <div ref={ ref => this.sectionRefMap[InfoSection.CONTACT] = ref }>
          <InfoContactContainer />
        </div>
        <div ref={ ref => this.sectionRefMap[InfoSection.ABOUT] = ref }>
          <InfoAboutContainer />
        </div>
        <div ref={ ref => this.sectionRefMap[InfoSection.CUSTOMER_SERVICE] = ref }>
          <InfoCustomerServiceContainer />
        </div>
        <div ref={ ref => this.sectionRefMap[InfoSection.FAQ] = ref }>
          <InfoFaqContainer />
        </div>
        <div ref={ ref => this.sectionRefMap[InfoSection.JOBS] = ref }>
          <InfoJobsContainer/>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetchingAbout: getIsFetchingAbout(state),
    isFetchingContact: getIsFetchingContact(state),
    isFetchingCustomerService: getIsFetchingCustomerService(state),
    isFetchingFaq: getIsFetchingFaq(state),
    isFetchingJobs: getIsFetchingJobs(state),
  }
}

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(InfoPageContainer);


// WEBPACK FOOTER //
// ./src/pages/InfoPage/InfoPageContainer.tsx